import axios from 'axios';

export default {
    name: 'review-helpful',

    props: {
        reviewId: Number,
        votesUp: {
            type: Number,
            default: 0
        },
        votesDown: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            action: 'none'
        };
    },

    methods: {
        upvote() {
            // if no action has been taken or review has been downvoted,
            // upvote the review
            if (this.action === 'none' || this.action === 'downvoted') {
                this.action = 'upvoted';
                axios.post(
                    `https://api.yotpo.com/reviews/${this.reviewId}/vote/up`
                );

                // if already upvoted, un-upvote
            } else {
                this.action = 'none';
                axios.post(
                    `https://api.yotpo.com/reviews/${this.reviewId}/vote/up/true`
                );
            }
        },
        downvote() {
            // if no action has been taken or review has been upvoted,
            // downvote the review
            if (this.action === 'none' || this.action === 'upvoted') {
                this.action = 'downvoted';
                axios.post(
                    `https://api.yotpo.com/reviews/${this.reviewId}/vote/down`
                );

                // if already downvoted, un-downvote
            } else {
                this.action = 'none';
                axios.post(
                    `http://api.yotpo.com/reviews/${this.reviewId}/vote/down/true`
                );
            }
        }
    },

    mounted() {}
};
